import axios, { AxiosRequestConfig } from "axios";

export interface Pessoa {
  codigo_dms_pessoa: number;
  nome_pessoa: string;
  identificador_pessoa: string;
  documento_pessoa: string;
}

export const getPessoas = async (
  token: string,
  tipo: number,
  usuarioId?: number,
): Promise<Pessoa[]> => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const query = usuarioId ? `?usuario_id=${usuarioId}` : "";
    const url = `${process.env.REACT_APP_API_DOMAIN}/atendimento/pessoa/${tipo}${query}`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar pessoas do atendimento:", error);
    throw error;
  }
};

export interface VinculoPayload {
  Usuario_Codigo: number;
  Usuario_Nome: string;
  Usuario_Identificador: string;
  Usuario_DocIdentificador: string;
  id_usuario: number;
}

export const vincularPessoa = async (
  token: string,
  payload: VinculoPayload,
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/atendimento/pessoa`;
    const response = await axios.post(url, payload, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao vincular pessoa ao DMS:", error);
    throw error;
  }
};
